import { IIntroState } from '../../types/redux/intro';

export const defaultState: IIntroState = {
  fromSaleRent: false,
  fromN1: false,
  fromBankiru: false,
  transactionId: null,
};

export function introReducer(state: IIntroState = defaultState) {
  return state;
}
